// AUTO-GENERATED CONFIG FILE - DO NOT EDIT
// Environment: production
// Territory: uk
// App: hub

const config = {
  "apiUrl": "https://api.motorplanpayments.co.uk",
  "apiTimeout": 30000,
  "appName": "MotorPlan Payments",
  "appVersion": "1.0.0",
  "currency": "GBP",
  "locale": "en-GB",
  "timezone": "Europe/London",
  "dateFormat": "DD/MM/YYYY",
  "phoneFormat": "+44",
  "vatRate": 0.2,
  "features": {
    "darkMode": true,
    "multiLanguage": false,
    "advancedAnalytics": true,
    "betaFeatures": false
  },
  "paymentMethods": [
    "card",
    "bank_transfer",
    "direct_debit",
    "bacs"
  ],
  "directDebit": {
    "serviceUserName": "MotorPlan Ltd",
    "advanceNoticeDays": 10,
    "guaranteeVersion": "2026-08-26",
    "logoUrl": "/direct-debit-logo.png"
  },
  "addressFormat": {
    "fields": [
      "line1",
      "line2",
      "town",
      "county",
      "postcode"
    ],
    "postcodeRegex": new RegExp("^[A-Z]{1,2}\\d[A-Z\\d]? ?\\d[A-Z]{2}$", "i"),
    "postcodeLabel": "Postcode"
  },
  "services": {
    "analytics": {
      "enabled": true,
      "provider": "google",
      "trackingId": "G-XXXXXXXXXX"
    },
    "sentry": {
      "enabled": true,
      "dsn": "",
      "environment": "production"
    },
    "stripe": {
      "enabled": true,
      "publishableKey": "pk_live_51T6TYVFaVegK865ukTNaYN4jAHzPkp2hkIyFOcWEJZFEbSjpZHLuaZLXPvEvu1FdzQefZ8uL1TmccplhW4ajSuzS00jAHF9do0"
    },
    "addressNow": {
      "key": "NY99-BY58-YF55-BZ63"
    }
  },
  "ui": {
    "theme": "light",
    "primaryColor": "#00b2a8",
    "logoUrl": "/logo.svg",
    "maxUploadSize": 10485760
  },
  "session": {
    "timeout": 3600000,
    "warningTime": 600000
  },
  "websocket": {
    "enabled": true,
    "driver": "pusher",
    "key": "5a286d6bdb852b3b1fb1",
    "host": null,
    "port": null,
    "cluster": "eu",
    "encrypted": true,
    "forceTLS": true,
    "enabledTransports": [
      "ws",
      "wss"
    ],
    "authEndpoint": "https://api.motorplanpayments.co.uk/broadcasting/auth"
  },
  "hubUrl": "https://hub.motorplanpayments.co.uk",
  "_meta": {
    "environment": "production",
    "territory": "uk",
    "app": "hub"
  }
};

// Helper functions similar to Laravel's EnvHelpers
export function getConfig(key, defaultValue = null) {
  const keys = key.split('.');
  let value = config;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return defaultValue;
    }
  }
  
  return value;
}

export function getEnvironment() {
  return config._meta.environment;
}

export function getTerritory() {
  return config._meta.territory;
}

export function isProduction() {
  return getEnvironment() === 'production';
}

export function isStaging() {
  return getEnvironment() === 'staging';
}

export function isDevelopment() {
  return getEnvironment() === 'dev';
}

export function getCurrency() {
  return getConfig('currency', 'GBP');
}

export function getLocale() {
  return getConfig('locale', 'en-GB');
}

export function getTimezone() {
  return getConfig('timezone', 'Europe/London');
}

export function getDateFormat() {
  return getConfig('dateFormat', 'DD/MM/YYYY');
}

export function getApiUrl() {
  return getConfig('apiUrl', 'http://localhost:12001');
}

export function getFeature(feature) {
  return getConfig(`features.${feature}`, false);
}

export function getService(service, key = null) {
  if (key) {
    return getConfig(`services.${service}.${key}`);
  }
  return getConfig(`services.${service}`);
}

export default config;
